import { Directive, HostListener, ElementRef } from '@angular/core';

@Directive({
  selector: '[mask-alphanumeric]'
})
export class MaskAlphanumericDirective {

  constructor(private el: ElementRef) {}

  @HostListener('input', ['$event'])
  onInput(event: Event): void {
    const input = event.target as HTMLInputElement;
    const uppercased = input.value.toUpperCase();
    if (input.value !== uppercased) {
      const start = input.selectionStart;
      const end = input.selectionEnd;
      input.value = uppercased;
      input.setSelectionRange(start, end);
      input.dispatchEvent(new Event('input', { bubbles: true }));
    }
  }
}
